module.exports = __webpack_public_path__ + "static/img/pipline1.c1e9b412.png";